import * as React from 'react';

// import { useEffect, useState } from 'react';
// import { useRouter } from 'next/router';

import { Footer } from '@/widgets/layouts/main/components/footer';
import { Header } from '@/widgets/layouts/main/components/header';
import { MarketingPopup } from './components/marketing-popup';
export interface MainLayoutProps {
  children?: React.ReactNode;
}
export const MainLayout = (props: MainLayoutProps): React.ReactNode => {
  const {
    children
  } = props;
  // const TIMER = 1000;

  // const [isMarketingPopupVisible, setMarketingPopupVisibility] = useState<boolean>(false);

  // const router = useRouter();
  // const isLandingPage = router.pathname === '/landing';
  // const isPaymentPage = router.pathname === '/payment';

  // useEffect(() => {
  //   if (isLandingPage || isPaymentPage) {
  //     return;
  //   }

  //   if (typeof window !== 'undefined' && window.localStorage) {
  //     const hasUserSeenMarketingPopup = localStorage.getItem('hasUserSeenMarketingPopup');

  //     const shouldShowPopup = hasUserSeenMarketingPopup !== 'true';

  //     if (shouldShowPopup) {
  //       const timer = setTimeout(() => {
  //         setMarketingPopupVisibility(true);
  //       }, TIMER);

  //       return () => clearTimeout(timer);
  //     }
  //   }
  // }, []);

  // useEffect(() => {
  //   if (isMarketingPopupVisible) {
  //     document.body.style.overflow = 'hidden';
  //   } else {
  //     document.body.style.overflow = '';
  //   }

  //   return () => {
  //     document.body.style.overflow = '';
  //   };
  // }, [isMarketingPopupVisible]);

  // const onPopupClose = () => {
  //   setMarketingPopupVisibility(false);
  //   localStorage.setItem('hasUserSeenMarketingPopup', 'true');
  // };

  return <>
      <Header />

      {children}

      {/* {isMarketingPopupVisible && !isLandingPage && !isPaymentPage && <MarketingPopup onCloseClick={onPopupClose} />} */}

      <Footer />
    </>;
};